<script setup lang="ts">
import { onMounted, computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'
import AuthLayout from '@/components/layout/AuthLayout.vue'

const router = useRouter()
const route = useRoute()

const isRouterReady = ref(false)

onMounted(async () => {
  // La sesión la restaura `main.ts` antes de montar, no aquí. `isRouterReady`
  // solo espera a que el router resuelva su primera navegación, que es lo que
  // decide qué maquetación se pinta.
  await router.isReady()
  isRouterReady.value = true
})

const currentLayout = computed(() => {
  if (!isRouterReady.value) return 'default'
  return route.meta.layout ?? 'default'
})
</script>

<template>
  <component :is="currentLayout === 'auth' ? AuthLayout : AppLayout">
    <RouterView v-slot="{ Component }">
      <component :is="Component" />
    </RouterView>
  </component>
</template>